<a class="block h-auto w-full max-w-logo" routerLink="/">
	<img class="block h-auto w-full max-w-logo" style="width: 50px; height: 72px" [src]="logoUrl" alt="infoday.io - Espresso Tutorials GmbH" />
</a>
